/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useLayoutEffect, useState } from "react";

const ModalDialog = (props) => {
    const {
        zIndex,
        classToUse,
        children,
        infoButtonRef
    } = props || {};
    
    const [location, setLocation] = useState({ top: 0, left: 0 });
    
    useLayoutEffect(() => {
        if (infoButtonRef?.current) {
            setLocation({
                left: (infoButtonRef?.current?.offsetLeft || 0) - 10,
                top: (infoButtonRef?.current?.offsetTop || 0) + 30,
            });
        }
    }, [infoButtonRef]);
    
    return (
        <div
            className={classToUse}
            style={{
                top: location.top,
                left: location.left,
                zIndex,
                position: "absolute",
                marginTop: "12px",
            }}
        >
            {children}
        </div>
    );
};

export { ModalDialog };
